var _defs, _path, _circle, _circle2, _path2, _path3, _path4, _path5, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeek(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 540",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #93d5d7;\n      }\n\n      .st1 {\n        fill: #29bfec;\n      }\n\n      .st2, .st3 {\n        stroke-miterlimit: 10;\n      }\n\n      .st2, .st4, .st5, .st6 {\n        fill: none;\n        stroke: #217d8c;\n      }\n\n      .st2, .st6 {\n        stroke-width: 27.83px;\n      }\n\n      .st3 {\n        fill: #cc3c27;\n        stroke: #cc3d27;\n        stroke-width: 3.84px;\n      }\n\n      .st4 {\n        stroke-width: 15.24px;\n      }\n\n      .st4, .st5 {\n        stroke-linecap: round;\n      }\n\n      .st4, .st5, .st6 {\n        stroke-linejoin: round;\n      }\n\n      .st5 {\n        stroke-width: 15.24px;\n      }\n\n      .st7 {\n        fill: #217d8c;\n      }\n\n      .st8 {\n        fill: #f47421;\n      }\n\n      .st9 {\n        fill: #edb48e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.9,55.77c10.26-2.77,32.29-2.46,48.98,1.12,66.75,14.34,108.88,81.88,95.31,145.03s-77.54,92.67-144.29,78.33c-11.89-2.56-23.04-6.48-33.26-11.56,0,0-3.92-15.73-.55-22.26s10.7-10.86,16.87-9.08,4.57,12.11,10.38,14.27,68.52-3.74,71.36-63.58c2.84-59.83-75.06-89.88-79.14-105.09-4.08-15.22,4.08-24.41,14.34-27.18h0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 197.23,
    cy: 164.69,
    r: 16
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 305.15,
    cy: 172.2,
    r: 16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M370.19,201.92c-13.57,63.15-77.54,92.67-144.29,78.33-11.89-2.56-23.04-6.48-33.26-11.56-47.11-23.44-74.34-71.52-63.2-123.42,10.17-47.36,49.34-81.46,96.45-89.5,15.7-2.68,32.29-2.46,48.98,1.12,66.75,14.34,108.88,81.88,95.31,145.03h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.14,318.79c17.76-8.92,28.55-12.97,62.29-12.97s51.31,4.34,64.11,12.97,26.3,81.49,38.44,139.52c2.05,9.79,3.94,19.04,5.62,27.75,8.23,42.9-220.17,47.97-216.43,13.53,1.8-16.52,4.42-34.62,7.05-53.43,8.1-58.03,21.17-118.46,38.92-127.38h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.6,486.06c-1.67-8.71-3.57-17.96-5.62-27.75-12.14-58.03-25.64-130.9-38.44-139.52-12.8-8.63-30.38-12.97-64.11-12.97s-44.53,4.05-62.29,12.97c0,0,.24,19.79,12.37,25.81,12.13,6.02,22.06,2.69,40.37,1.53,18.32-1.16,28.08,2.45,38.84,16.35s16.8,65.82,17.37,97.61c.41,23.14.23,41.02-8.98,58.7-3.44,6.61,78.71,10.18,70.48-32.73h.01Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M185.14,318.79c17.76-8.92,28.55-12.97,62.29-12.97s51.31,4.34,64.11,12.97,26.3,81.49,38.44,139.52c1.38,6.57,2.68,12.9,3.9,18.99.6,2.98,1.47,5.86,1.72,8.76.9,10.71-56.91,36.43-110.54,38.73-57.28,2.46-105.71-17.83-105.54-28.29.26-15.77,4.24-32.7,6.7-50.34,8.1-58.03,21.17-118.46,38.92-127.38h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 310.09,
    cy: 172.7,
    rx: 42.37,
    ry: 42.27,
    transform: "translate(117.64 470.93) rotate(-86.28)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 352.16,
    y1: 175.42,
    x2: 391.12,
    y2: 178.49
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 193.54,
    cy: 165.12,
    rx: 42.37,
    ry: 42.27,
    transform: "translate(16.21 347.54) rotate(-86.28)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 151.34,
    y1: 162.37,
    x2: 108.72,
    y2: 158.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M265.05,169.76c-2.96-3.96-7.59-6.54-12.91-6.89-5.24-.34-10.25,1.69-13.69,5.16"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 110.89,
    y: 313.86,
    width: 67.38,
    height: 101.07,
    rx: 12.63,
    ry: 12.63,
    transform: "translate(-135.66 90.26) rotate(-23.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129.2,371.23c2.28,5.13-5.41,8.56-7.69,3.42-2.28-5.13,5.41-8.56,7.69-3.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M148.43,362.66c2.28,5.13-5.41,8.56-7.69,3.42-2.28-5.13,5.41-8.56,7.69-3.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M167.67,354.1c2.28,5.13-5.41,8.56-7.69,3.42-2.28-5.13,5.41-8.56,7.69-3.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M136.05,386.62c2.28,5.13-5.41,8.56-7.69,3.42-2.28-5.13,5.41-8.56,7.69-3.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M155.28,378.05c2.28,5.13-5.41,8.56-7.69,3.42-2.28-5.13,5.41-8.56,7.69-3.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M142.89,402c2.28,5.13-5.41,8.56-7.69,3.42-2.28-5.13,5.41-8.56,7.69-3.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M162.13,393.44c2.28,5.13-5.41,8.56-7.69,3.42-2.28-5.13,5.41-8.56,7.69-3.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.7,346.87l30.82,69.25c4.73,10.62,17.18,15.4,27.8,10.67l38.47-17.12c10.62-4.73,15.4-17.18,10.67-27.8l-30.82-69.25c-4.73-10.62-17.18-15.4-27.8-10.67l-38.47,17.12c-10.62,4.73-15.4,17.18-10.67,27.8h0ZM159.95,316.05l30.82,69.25c2.83,6.35-.06,13.85-6.4,16.68l-38.47,17.12c-6.35,2.83-13.85-.06-16.68-6.4l-30.82-69.25c-2.83-6.35.06-13.85,6.4-16.68l38.47-17.12c6.35-2.83,13.85.06,16.68,6.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M168.96,367.36c-2.12.94-3.08,3.44-2.13,5.56l6.85,15.39c.94,2.12,3.44,3.08,5.56,2.13s3.08-3.44,2.13-5.56l-6.85-15.39c-.94-2.12-3.44-3.08-5.56-2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M107.8,343.87l6.85,15.39c.94,2.12,3.44,3.08,5.56,2.13l38.47-17.12c2.12-.94,3.08-3.44,2.13-5.56l-6.85-15.39c-.94-2.12-3.44-3.08-5.56-2.13l-38.47,17.12c-2.12.94-3.08,3.44-2.13,5.56ZM117.21,344.3l30.78-13.7,3.42,7.69-30.78,13.7s-3.42-7.69-3.42-7.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 117.46,
    y: 337.09,
    width: 33.69,
    height: 8.42,
    transform: "translate(-127.16 84.09) rotate(-23.99)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeek);
export default __webpack_public_path__ + "static/media/geek.cf7271dd355c6ac20dcd9581afe14796.svg";
export { ForwardRef as ReactComponent };